import React from 'react';
import PropTypes from 'prop-types';

const MyDomains = ({ altText }) => {
  return (
    <svg width='1.5em' height='1.5em' xmlns='http://www.w3.org/2000/svg' role='img' aria-labelledby='my-domains-title'>
      <title id='my-domains-title'>{altText}</title>
      <path d='M2 2v20h20V2H2zm18 18H4V4h16v16z' />
      <path d='M18 9V7h-8v2h8zM18 11h-8v2h8v-2zM18 15h-8v2h8v-2zM7 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' />
    </svg>
  );
};

MyDomains.propTypes = {
  altText: PropTypes.string
};

export default MyDomains;
